export default __webpack_public_path__ + "static/media/CX_LOGO_32PX.437d2d65.svg";